<ng-container *ngIf="(userData.UserResolved$ | async)">
  <app-header></app-header>
  <main role="main">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</ng-container>